import { ChangeDetectionStrategy, Component, Inject, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DeviceButtonTemplatesListComponent } from './device-button-templates-list/device-button-templates-list.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  DeviceButtonTemplateEditDialogComponent,
  DeviceButtonTemplateEditDialogData,
} from '../device-button-template-edit-dialog/device-button-template-edit-dialog.component';

export interface DeviceButtonTemplatesListDialogData {
  isExpansionAvailable: boolean;
}

@Component({
  selector: 'app-device-button-templates-dialog',
  standalone: true,
  imports: [MatIconModule, MatDialogModule, MatButtonModule, FlexLayoutModule, DeviceButtonTemplatesListComponent],
  templateUrl: './device-button-templates-list-dialog.component.html',
  styleUrl: './device-button-templates-list-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceButtonTemplatesListDialogComponent {
  public readonly buttonTemplateList = viewChild(DeviceButtonTemplatesListComponent);

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: DeviceButtonTemplatesListDialogData,

    private readonly _dialog: MatDialog,
  ) {}

  get isExpansionAvailable(): boolean {
    return this._data.isExpansionAvailable;
  }

  public onAddTemplate(): void {
    const dialogRef = this._dialog.open<
      DeviceButtonTemplateEditDialogComponent,
      DeviceButtonTemplateEditDialogData,
      boolean
    >(DeviceButtonTemplateEditDialogComponent, {
      data: {
        templateId: 'new',
      },
      width: '800px',
      height: '70%',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buttonTemplateList().loadData();
      }
    });
  }
}
